/* tslint:disable */
/* eslint-disable */
/**
 * esign
 * eSign template authoring and request management service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const EsignTemplateStatus = {
    Draft: 'draft',
    Published: 'published',
    Archived: 'archived',
} as const;
export type EsignTemplateStatus = typeof EsignTemplateStatus[keyof typeof EsignTemplateStatus];


export function instanceOfEsignTemplateStatus(value: any): boolean {
    for (const key in EsignTemplateStatus) {
        if (Object.prototype.hasOwnProperty.call(EsignTemplateStatus, key)) {
            if (EsignTemplateStatus[key as keyof typeof EsignTemplateStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function EsignTemplateStatusFromJSON(json: any): EsignTemplateStatus {
    return EsignTemplateStatusFromJSONTyped(json, false);
}

export function EsignTemplateStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): EsignTemplateStatus {
    return json as EsignTemplateStatus;
}

export function EsignTemplateStatusToJSON(value?: EsignTemplateStatus | null): any {
    return value as any;
}

export function EsignTemplateStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): EsignTemplateStatus {
    return value as EsignTemplateStatus;
}

